import { ActivatedRoute, Router } from "@angular/router";
import { TowerService } from "../../api/service/tower.service";
import { NavigationService } from "../../shared/navigation.service";
var CallbackComponent = /** @class */ (function () {
    function CallbackComponent(router, route, towerService, navigationService) {
        this.router = router;
        this.route = route;
        this.towerService = towerService;
        this.navigationService = navigationService;
    }
    CallbackComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.fragment.subscribe(function (fragment) {
            _this.towerService.obtainToken(fragment).subscribe(function (response) {
                _this.navigationService.setToken(response);
                _this.towerService.setAccessToken(response.accessToken);
                _this.router.navigate(['/home']);
            }, function (error) {
                alert('Erreur durant la connexion');
            });
        });
    };
    return CallbackComponent;
}());
export { CallbackComponent };



// WEBPACK FOOTER //
// ./src/app/page/callback/callback.component.ts.pre-build-optimizer.js